<template>
  <menu-page-horizontal :items="getItems(id, active)" />
</template>

<script setup>
import { onMounted } from "vue";
import MenuPageHorizontal from "@/views/portal/components/menus/MenuPageHorizontal.vue";

defineProps({
  id: {
    type: Number,
    default: 0,
    required: true,
  },
  active: {
    type: String,
    default: "about",
  },
});

const getItems = (id, active) => {
  return [
    {
      label: "О публикации",
      url: "/portal/publication/" + id,
      active: active === "about" || !active,
    },
    {
      label: "Направления работы",
      url: "/portal/publication/" + id + "/concepts",
      active: active === "concepts",
    },
    {
      label: "Цитирование",
      // url: "/portal/publication/" + id + "/citations",
      url: "/portal/publication/" + id + "/citations",
      active: active === "citations",
    },
  ];
};

onMounted(() => {});
</script>

<style lang="scss" scoped></style>
